import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "goods-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "goods-list"
};
const _hoisted_6 = {
  class: "dialog-content"
};
const _hoisted_7 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted, onUnmounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";
import { deleteProductByIdApi, deleteProductBatchApi, getProductCategoryListApi, getProductListByPageApi, shelfProductApi, importGoods } from "@/service/modules/product";
import protoPagination from "@/components/proto-pagination.vue";
import { addLoading } from "@/utils/element-method";
export default {
  __name: 'goods',
  setup(__props) {
    const router = useRouter();

    // 定义查询参数
    const queryParams = reactive({
      productName: "",
      categoryId: undefined,
      startShelfTime: undefined,
      endShelfTime: undefined,
      isShelf: true
    });
    const props = {
      children: "secondCategory",
      label: "categoryName",
      value: "id",
      emitPath: false,
      leaf: ''
    };
    // 分页对象
    const page = reactive({
      page: 1,
      pageSize: 10,
      limit: 10
    });

    // 日期范围
    const dateRange = ref([]);

    // 类目选项
    const categoryOptions = ref([]);

    // 商品列表数据
    const goodsList = ref([]);
    const selectedGoods = ref([]);
    const total = ref(0);
    const loading = ref(false);

    // 当前选中的tab
    const activeName = ref("first");

    // 下架弹窗相关
    const offShelfDialogVisible = ref(false);
    const currentGood = ref({});

    // 表格引用
    const tableRef = ref(null);
    onMounted(() => {
      getList();
      getCategoryList();
    });

    // 处理表格选择变化
    const handleSelectionChange = selection => {
      selectedGoods.value = selection;
    };

    // 批量删除
    const handleDeleteBatch = () => {
      if (selectedGoods.value.length === 0) {
        ElMessage.warning("请选择要删除的商品");
        return;
      }
      ElMessageBox.confirm(`确定删除选中的 ${selectedGoods.value.length} 个商品吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const ids = selectedGoods.value.map(good => good.id);
          await deleteProductBatchApi(ids);
          ElMessage.success("批量删除成功");
          selectedGoods.value = [];
          getList();
        } catch (error) {
          console.error("批量删除失败", error);
          ElMessage.error("批量删除失败");
        }
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
      });
    };

    // 切换tab
    const handleClick = (tab, event) => {
      console.log(123, tab, tab.props.name);
      activeName.value = tab.props.name;
      if (tab.props.name === "first") {
        queryParams.isShelf = true;
        getList();
      } else {
        queryParams.isShelf = false;
        getList();
      }
    };

    // 日期变化处理
    const handleDateChange = val => {
      if (val) {
        queryParams.startShelfTime = val[0];
        queryParams.endShelfTime = val[1];
      } else {
        queryParams.startShelfTime = undefined;
        queryParams.endShelfTime = undefined;
      }
    };

    // 查询按钮
    const handleQuery = () => {
      page.page = 1;
      getList();
    };

    // 重置查询
    const resetQuery = () => {
      dateRange.value = [];
      Object.assign(queryParams, {
        page: 1,
        pageSize: 10,
        productName: "",
        categoryId: undefined,
        startShelfTime: undefined,
        endShelfTime: undefined
      });
      page.page = 1;
      getList();
    };
    async function getCategoryList() {
      let res = await getProductCategoryListApi();
      categoryOptions.value = res.data;
    }

    // 获取商品列表数据
    async function getList() {
      // loading.value = true;
      // 这里使用模拟数据，实际项目中应该调用后端接口
      console.log(queryParams, 123);
      let res = await getProductListByPageApi({
        ...page,
        current: page.page,
        size: page.pageSize,
        ...queryParams
      });
      goodsList.value = res.data.records;
      total.value = Number(res.data.total);
    }

    // 新增商品
    const handleAdd = () => {
      router.push("/product/goods-add");
    };

    // 下架操作
    const handleOffShelf = row => {
      currentGood.value = row;
      offShelfDialogVisible.value = true;
    };

    // 确认下架
    const confirmOffShelf = async () => {
      try {
        let res = await shelfProductApi({
          productId: currentGood.value.id,
          isShelf: false
        });
        ElMessage.success("商品下架成功");
        offShelfDialogVisible.value = false;
        getList();
      } catch (e) {
        console.error("下架失败:", e);
        ElMessage.error("下架失败，请重试");
        offShelfDialogVisible.value = false;
      }
    };

    // 上架操作
    const handleOnShelf = row => {
      ElMessageBox.confirm(`确认要上架商品 "${row.productName}" 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          let res = await shelfProductApi({
            productId: row.id,
            isShelf: true
          });
          ElMessage.success("商品上架成功");
          offShelfDialogVisible.value = false;
          getList();
        } catch (e) {
          console.error("上架失败:", e);
          ElMessage.error("上架失败，请重试");
        }
      }).catch(() => {
        // 取消操作
      });
    };

    // 编辑操作
    const handleEdit = row => {
      router.push(`/product/goods-add?id=${row.id}`);
    };

    // 删除操作
    const handleDelete = row => {
      ElMessageBox.confirm(`确认要删除商品 "${row.productName}" 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          let res = await deleteProductByIdApi(row.id);
          ElMessage.success("商品删除成功");
          getList();
        } catch (e) {
          console.error("删除失败:", e);
          ElMessage.error("删除失败，请重试");
        }
      }).catch(() => {
        // 取消操作
      });
    };

    // 分页相关方法
    const handleCurrentChange = val => {
      page.page = val;
      getList();
    };
    function handleImport() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx,.xls,.csv";
      input.onchange = async event => {
        const file = event.target.files?.[0];
        if (!file) return;
        const loading = addLoading();
        try {
          const formData = new FormData();
          formData.append("file", file);
          await importGoods(formData);
          ElMessage.success("导入成功");
          getList(); // 刷新列表
        } catch (error) {
          ElMessage.error("导入失败：" + error.message);
        } finally {
          loading.close(); // 无论成功还是失败，都关闭loading
        }
      };
      input.click();
    }
    const handleSizeChange = val => {
      page.pageSize = val;
      getList();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createTextVNode(" 商品管理 ")), _createVNode(_component_el_button, {
        onClick: handleAdd,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("发布产品")])),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: handleDeleteBatch,
        type: "danger",
        style: {
          "margin-left": "5px"
        },
        disabled: selectedGoods.value.length === 0
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("批量删除")])),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "上架中",
          name: "first"
        }), _createVNode(_component_el_tab_pane, {
          label: "已下架",
          name: "second"
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: queryParams,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: dateRange.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dateRange.value = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD",
            onChange: handleDateChange,
            style: {
              "width": "240px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: queryParams.categoryId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.categoryId = $event),
            placeholder: "请选择类目",
            clearable: "",
            style: {
              "width": "180px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.categoryName,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: queryParams.productName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => queryParams.productName = $event),
            style: {
              "width": "180px"
            },
            placeholder: "请输入商品名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: handleQuery
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("查询")])),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: resetQuery
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("重置")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "success",
            onClick: handleImport
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("导入")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: goodsList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        style: {
          "width": "100%"
        },
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "id",
          label: "商品ID",
          "min-width": "60"
        }), _createVNode(_component_el_table_column, {
          label: "商品封面",
          "min-width": "60"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_image, {
            style: {
              "width": "40px",
              "height": "40px"
            },
            fit: "cover",
            src: scope.row.mainImage
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "productName",
          label: "商品名称",
          "min-width": "150",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "categoryName",
          label: "类目",
          "min-width": "80"
        }), _createVNode(_component_el_table_column, {
          prop: "price",
          label: "最低价格",
          "min-width": "80"
        }, {
          default: _withCtx(scope => [_createTextVNode(" ¥" + _toDisplayString(scope.row.price), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "maxPrice",
          label: "最高价格",
          "min-width": "80"
        }, {
          default: _withCtx(scope => [_createTextVNode(" ¥" + _toDisplayString(scope.row.maxPrice), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "shelfTime",
          label: "上架时间",
          "min-width": "120",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "120",
          fixed: "right"
        }, {
          default: _withCtx(scope => [scope.row.isShelf ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            class: "m-r-10",
            type: "warning",
            onClick: $event => handleOffShelf(scope.row)
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("下架")])),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_link, {
            key: 1,
            class: "m-r-10",
            type: "success",
            onClick: $event => handleOnShelf(scope.row)
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("上架")])),
            _: 2
          }, 1032, ["onClick"])), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleEdit(scope.row)
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page", "total"])])]), _createVNode(_component_el_dialog, {
        modelValue: offShelfDialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => offShelfDialogVisible.value = $event),
        title: "操作确认",
        width: "400px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => offShelfDialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmOffShelf
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("确认")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, "确认要下架商品 \"" + _toDisplayString(currentGood.value.productName) + "\" 吗？", 1)])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};